module.exports = __webpack_public_path__ + "img/3.cdb1a53a.jpg";